import React, { useMemo } from "react"
import { useStaticQuery, graphql } from "gatsby"
import Image from "gatsby-image"
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  media: {
    flexGrow: 1,
    height: 30,
    margin: `auto !important`,
  },
}));

export default ({ src }) => {
  //console.log(src)
  const classes = useStyles();
  const data = useStaticQuery(graphql`
    query {
      allFile(filter: {relativeDirectory: {eq: "weather"}}) {
        edges {
          node {
            relativePath
            childImageSharp {
              fluid(maxWidth: 40) {
                ...GatsbyImageSharpFluid
              }
            }
          }
        }
      }
    }
  `)
  const match = useMemo(() => (
    data.allFile.edges.find(({ node }) => src === node.relativePath)
  ), [ data, src ])

  return(
    <Image
      fluid={match.node.childImageSharp.fluid}
      alt={src || ``}
      className={classes.media}
      imgStyle={{ objectPosition: 'center', objectFit: 'contain', }}
    />
  )
}